import { BRAND } from "../../brand";

const accentColor = BRAND.magenta;

const Toggle = ({ on, disabled, onChange, suppressPropagation = false }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={(e) => {
      if (suppressPropagation) e.stopPropagation();
      if (!disabled) onChange(!on);
    }}
    className={`relative inline-flex h-7 w-16 items-center rounded-full transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-navy focus-visible:ring-brand-pink ${
      disabled ? "cursor-not-allowed opacity-40 bg-brand-navy" : "bg-brand-navy"
    }`}
    style={!disabled && on ? { backgroundColor: accentColor } : undefined}
  >
    <span
      className={`inline-block h-6 w-6 transform rounded-full bg-white shadow-md transition-transform duration-200 ${
        on ? "translate-x-9" : "translate-x-1"
      }`}
      style={!disabled && on ? { boxShadow: `0 0 0 1px ${accentColor}` } : undefined}
    />
  </button>
);

export default Toggle;
